import { EQUITY_ALLOCATION_KEY } from '../../../../common/constants/equityAllocation';


/**
 * @description Generates the key for the equity allocation configuration, if the related entity id is provided, it will be used to generate a unique key
 * @param relatedEntityId {string} - The id of the related entity
 * @returns {string} The unique key for the equity allocation configuration
 */
const generateEquityAllocationKey = (relatedEntityId?: string): string => relatedEntityId ? `${EQUITY_ALLOCATION_KEY}_${relatedEntityId}` : EQUITY_ALLOCATION_KEY;

export default generateEquityAllocationKey;
